// extracted by mini-css-extract-plugin
export default {"text":"CheckinInfoCardItem-module__text___kjDjD","clipboardButton":"CheckinInfoCardItem-module__clipboardButton___YT7_y"};